import { connect } from 'react-redux';
import Marker from '../components/Marker';
import { highlightShop, unhighlightShop, selectShop, deselectShop } from '../actions';

const mapStateToProps = ({ highlightedShop, selectedShop, shops }, { parcelShopNumber, isDisabled }) => {
  // assigning the sortCode1 here leads to an error
  //const isDisabled = !!config.sortCode1 && sortCode1 !== parseInt(config.sortCode1, 10);

  return {
    isHighlighted: highlightedShop == parcelShopNumber,
    isSelected: selectedShop == parcelShopNumber,
    details: shops[parcelShopNumber],
    isDisabled: isDisabled
  }
};

const mapDispatchToProps = dispatch => ({
  onMouseOver: parcelShopNumber => dispatch(highlightShop(parcelShopNumber)),
  onMouseOut: () => dispatch(unhighlightShop()),
  onCloseClick: () => dispatch(deselectShop()),
  onClick: (parcelShopNumber, isSelected, isDisabled) => {

    if (isSelected) {
      // was selected, deselect it
      dispatch(deselectShop());
    } else {
      // was not selected, select it
      dispatch(selectShop(parcelShopNumber, isDisabled)); // isDisabled logic is passed for "wrong-code" check in showCallbackButton.js
    }
  }
});

const MarkerContainer = connect(mapStateToProps, mapDispatchToProps)(Marker);

export default MarkerContainer;
